export function getSearchParams(searchValue) {
	const trimmed = searchValue.trim()

	if (trimmed.startsWith("#")) {
		return {
			type: "orderNumber",
			value: trimmed.substring(1), // remove the #
		}
	}

	if (trimmed.toUpperCase().startsWith("CHE")) {
		return {
			type: "cheCode",
			value: trimmed,
		}
	}

	if (searchValue === "") {
		return {
			type: null,
			value: null,
		}
	}

	// fallback
	return {
		type: "name",
		value: trimmed,
	}
}
